// extracted by mini-css-extract-plugin
export default {"root":"side_panel-modules___root___c81c1b74","show":"side_panel-modules___show___d44950de","secondPanel":"side_panel-modules___secondPanel___cda82d39"};